//NATAL CHART from Rinoa - tutorial box with Hide and Unhide button

import React, { useEffect, useState } from "react";
import axios from "axios";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import { useNavigate, useLocation } from "react-router-dom";
import DigitalCharm from "./Account/DigitalCharm";
import bg from "./Assets/Xianhe New Assets/bg.png";

import image1 from "./Assets/Questions/mountain.JPG";
import image2 from "./Assets/Questions/2.jpg";
import image3 from "./Assets/Questions/3.jpg";
import image4 from "./Assets/Questions/4.jpg";
import image5 from "./Assets/Questions/5.jpg";
import image6 from "./Assets/Questions/6.jpg";
import image7 from "./Assets/Questions/7.jpg";
import image8 from "./Assets/Questions/8.jpg";
import image9 from "./Assets/Questions/9.jpg";
import image10 from "./Assets/Questions/10.jpg";
import testImage from "./Assets/amulet.png";
import TipsChatbot from "./ChatBot/TipsChatbot";
import { useTranslation } from "react-i18next";
import NataChart2 from "./NataChart2";
import {
  FaQuestionCircle,
  FaCalendarDay,
  FaCalendarWeek,
  FaCalendarAlt,
  FaCalendarCheck,
} from "react-icons/fa";
import {
  bgNatal as natalBg,
  natalArrow,
  natalTitleFooter,
  knowyourself,
  thewheel,
  studio,
  amu,
} from "./Assets/Xianhe New Assets/natal-assets";

const NatalTabButton = ({ active, onClick, children }) => (
  <button
    onClick={onClick}
    style={{
      display: "flex",
      alignItems: "center",
      padding: "10px 30px",
      backgroundColor: active ? "#deaf77" : "#0A031E",
      color: active ? "#000" : "#deaf77",
      border: "1px solid #deaf77",
      borderRadius: "8px",
      cursor: "pointer",
      fontWeight: "600",
      fontSize: "16px",
      fontFamily: "'PlayfairDisplay', serif",
      transition: "all 0.3s ease",
      minWidth: "120px",
      justifyContent: "center",
    }}
  >
    {children}
  </button>
);

const FeatureIcon = ({ image, title, description, active, isMobile }) => (
  <div
    style={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      textAlign: "center",
      width: isMobile ? "100%" : "220px",
      opacity: active ? 1 : 0.7,
      transition: "opacity 0.3s ease",
      padding: "0 10px",
    }}
  >
    <div
      style={{
        width: "40px",
        height: "40px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        marginBottom: "12px",
      }}
    >
      <img
        src={image}
        alt={title}
        style={{ width: "40px", height: "40px", objectFit: "contain" }}
      />
    </div>
    <h4
      style={{
        color: "#fff",
        fontFamily: "'PlayfairDisplay', serif",
        margin: "0 0 8px 0",
        fontSize: "18px",
        fontWeight: "bold",
      }}
    >
      {title}
    </h4>
    <p
      style={{
        color: "rgba(255,255,255,0.7)",
        fontSize: "13px",
        margin: 0,
        lineHeight: "1.5",
        maxWidth: "180px",
      }}
    >
      {description}
    </p>
  </div>
);

const DottedLine = ({ isMobile }) =>
  isMobile ? null : (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        height: "40px",
        margin: "0 -45px",
        zIndex: 1,
      }}
    >
      <img
        src={natalArrow}
        alt="arrow"
        style={{ width: "130px", height: "8px", opacity: 1 }}
      />
    </div>
  );

const JourneySection = ({ isMobile, t, onNavigate }) => (
  <div
    style={{
      width: "100%",
      maxWidth: "1400px",
      margin: "60px auto 30px auto",
      textAlign: "center",
      color: "#deaf77",
      position: "relative",
      zIndex: 2,
      transform: "scale(0.85)",
      transformOrigin: "top center",
    }}
  >
    <h1
      style={{
        fontFamily: "'PlayfairDisplay', serif",
        fontSize: isMobile ? "36px" : "54px",
        fontWeight: "700",
        marginBottom: "15px",
        color: "#deaf77",
      }}
    >
      {t("natalChart.topheader", "Your Journey starts here.")}
    </h1>
    <p
      style={{
        fontFamily: "'DMSans', sans-serif",
        fontSize: isMobile ? "16px" : "20px",
        marginBottom: "60px",
        opacity: 0.9,
        color: "#fff",
      }}
    >
      {t(
        "natalChart.topheader2",
        "Explore your tools for clarity, guidance and growth:",
      )}
    </p>

    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: isMobile ? "center" : "flex-start",
        flexDirection: isMobile ? "column" : "row",
        gap: isMobile ? "14px" : "0px",
        flexWrap: "nowrap",
        padding: "0 20px",
        width: "100%",
        overflowX: isMobile ? "visible" : "hidden",
      }}
    >
      <FeatureIcon
        image={knowyourself}
        title={t("natalChart.subheader1", "Life Forecast")}
        description={t(
          "natalChart.subheader1desc",
          "See your daily, monthly, and yearly energies at a glance.",
        )}
        active={true}
        isMobile={isMobile}
      />
      <DottedLine isMobile={isMobile} />
      <div
        onClick={() => onNavigate && onNavigate("/fortune-stick")}
        style={{ cursor: "pointer" }}
      >
        <FeatureIcon
          image={thewheel}
          title={t("natalChart.subheader2", "The Wheel")}
          description={t(
            "natalChart.subheader2desc",
            "Ask a question and receive instant higher guidance.",
          )}
          active={true}
          isMobile={isMobile}
        />
      </div>
      <DottedLine isMobile={isMobile} />
      <div
        onClick={() => onNavigate && onNavigate("/courses")}
        style={{ cursor: "pointer" }}
      >
        <FeatureIcon
          image={studio}
          title={t("natalChart.subheader3", "Self-Mastery")}
          description={t(
            "natalChart.subheader3desc",
            "Take powerful courses to raise energy and intuition.",
          )}
          active={true}
          isMobile={isMobile}
        />
      </div>
      <DottedLine isMobile={isMobile} />
      <div
        onClick={() => onNavigate && onNavigate("/DigitalCharm")}
        style={{ cursor: "pointer" }}
      >
        <FeatureIcon
          image={amu}
          title={t("natalChart.subheader4", "Blessed Amulets")}
          description={t(
            "natalChart.subheader4desc",
            "Shop powerful charms for luck, clarity, protection, and abundance.",
          )}
          active={true}
          isMobile={isMobile}
        />
      </div>
    </div>

    {/* Decorative Flourish */}
    <div
      style={{
        marginTop: "60px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        opacity: 1,
      }}
    >
      <img
        src={natalTitleFooter}
        alt="flourish"
        style={{ width: isMobile ? "280px" : "450px", height: "auto" }}
      />
    </div>
  </div>
);

const Modal = ({ isOpen, onClose, content }) => {
  if (!isOpen) return null;
  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0, 0, 0, 0.6)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 999,
      }}
    >
      <div
        style={{
          backgroundColor: "#fff",
          padding: "20px",
          borderRadius: "10px",
          maxWidth: "500px",
          width: "90%",
          boxShadow: "0 4px 12px rgba(0,0,0,0.3)",
        }}
      >
        <h3 style={{ marginBottom: "10px", color: "#333" }}>
          💡 Feng Shui Tip
        </h3>
        <p style={{ whiteSpace: "pre-wrap" }}>{content}</p>
        <button
          onClick={onClose}
          style={{
            marginTop: "20px",
            backgroundColor: "#333",
            color: "#fff",
            border: "none",
            padding: "8px 16px",
            borderRadius: "5px",
            cursor: "pointer",
          }}
        >
          Close
        </button>
      </div>
    </div>
  );
};

const CircleContainer = (
  { children }, //container holding the circles with percentages
) => (
  <div
    style={{
      display: "flex",
      justifyContent: "center",
      flexWrap: "wrap",
      gap: "10px",
      marginBottom: "40px",
    }}
  >
    {children}
  </div>
);

const DestinyHeader = ({ lunarData, t, isMobile }) => {
  const [showBaziTooltip, setShowBaziTooltip] = useState(false);
  const [showZodiacTooltip, setShowZodiacTooltip] = useState(false);

  const tooltipStyle = {
    position: isMobile ? "fixed" : "absolute",
    ...(isMobile
      ? { bottom: "50%", left: "50%", transform: "translate(-50%, 50%)" }
      : {
          bottom: "calc(100% + 10px)",
          left: "50%",
          transform: "translateX(-50%)",
        }),
    backgroundColor: "rgba(10, 3, 30, 1)",
    border: "1px solid #deaf77",
    borderRadius: "10px",
    padding: "12px 16px",
    color: "#fff",
    fontSize: "13px",
    lineHeight: "1.6",
    width: isMobile ? "85vw" : "400px",
    maxWidth: "400px",
    whiteSpace: "pre-wrap",
    boxShadow: "0 6px 20px rgba(0,0,0,0.5)",
    zIndex: 1000,
    fontFamily: "'DMSans', sans-serif",
    pointerEvents: "none",
  };

  return (
    <div
      style={{
        backgroundColor: "rgba(10, 3, 30, 0.6)",
        border: "1px solid #deaf77",
        borderRadius: "20px",
        padding: isMobile ? "20px" : "30px 40px",
        width: "100%",
        maxWidth: "1100px",
        margin: "0 auto 20px auto",
        textAlign: "left",
        boxShadow: "0 10px 30px rgba(0,0,0,0.5)",
        display: "flex",
        flexDirection: "column",
        gap: "10px",
      }}
    >
      <h2
        style={{
          color: "#deaf77",
          fontSize: isMobile ? "20px" : "28px",
          fontFamily: "'PlayfairDisplay', serif",
          margin: 0,
          fontWeight: "700",
        }}
      >
        {t("natalChart.header")}
      </h2>
      <h3
        style={{
          color: "#fff",
          fontSize: isMobile ? "18px" : "22px",
          fontFamily: "'DMSans', sans-serif",
          margin: 0,
          fontWeight: "500",
        }}
      >
        {t("natalChart.yourLifeChart")}
      </h3>
      <div
        style={{
          display: "flex",
          gap: isMobile ? "15px" : "40px",
          flexWrap: "wrap",
          color: "rgba(255,255,255,0.7)",
          fontSize: isMobile ? "14px" : "16px",
          fontFamily: "'DMSans', sans-serif",
          alignItems: "center",
          marginTop: "10px",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <span style={{ opacity: 0.8 }}>
            {t("natalChart.baziPersonality")}
          </span>
          <span style={{ color: "#fff", fontWeight: "500" }}>
            {lunarData?.STEM_RELATION} {lunarData?.NATAL}
          </span>
          <div
            style={{
              position: "relative",
              display: "inline-flex",
              alignItems: "center",
            }}
          >
            <FaQuestionCircle
              style={{ color: "#deaf77", fontSize: "14px", cursor: "pointer" }}
              onMouseEnter={() => setShowBaziTooltip(true)}
              onMouseLeave={() => setShowBaziTooltip(false)}
            />
            {showBaziTooltip && lunarData?.STEM_DESCRIPTION && (
              <div
                style={tooltipStyle}
                className="destiny-tooltip"
                dangerouslySetInnerHTML={{ __html: lunarData.STEM_DESCRIPTION }}
              />
            )}
          </div>
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <span style={{ opacity: 0.8 }}>{t("natalChart.chineseZodiac")}</span>
          <span style={{ color: "#fff", fontWeight: "500" }}>
            {lunarData?.ZODIAC} {lunarData?.ZODIAC_CN}
          </span>
          <div
            style={{
              position: "relative",
              display: "inline-flex",
              alignItems: "center",
            }}
          >
            <FaQuestionCircle
              style={{ color: "#deaf77", fontSize: "14px", cursor: "pointer" }}
              onMouseEnter={() => setShowZodiacTooltip(true)}
              onMouseLeave={() => setShowZodiacTooltip(false)}
            />
            {showZodiacTooltip && lunarData?.ZODIAC_DESCRIPTION && (
              <div
                style={tooltipStyle}
                className="destiny-tooltip"
                dangerouslySetInnerHTML={{
                  __html: lunarData.ZODIAC_DESCRIPTION,
                }}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

const ForecastChart = () => {
  const [lunarData, setLunarData] = useState(null);
  const [activeTab, setActiveTab] = useState("daily");
  const [forecastTables, setForecastTables] = useState([null, null, null]); // [daily, monthly, yearly]
  const [selectedChartLabel, setSelectedChartLabel] = useState(null);
  const [chartDataForChatbot, setChartDataForChatbot] = useState(null);
  const userID = localStorage.getItem("userID");
  const userName = localStorage.getItem("username");
  // Debugging: log localStorage user values to track unexpected redirects
  console.log("NatalChart debug - localStorage:", { userID, userName });
  const [recommendedCharms, setRecommendedCharms] = useState([]);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 600);
  const [fetchError, setFetchError] = useState(null);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 600);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const [isDobMissing, setIsDobMissing] = useState(false);

  const [tipModalOpen, setTipModalOpen] = useState(false);
  const [tipContent, setTipContent] = useState("");
  const [tipsData, setTipsData] = useState({
    Life: [],
    Daily: [],
    Monthly: [],
    Yearly: [],
  });
  const [currentTipIndex, setCurrentTipIndex] = useState({
    Life: 0,
    Daily: 0,
    Monthly: 0,
    Yearly: 0,
  });
  const [showTipsChatbot, setShowTipsChatbot] = useState(false);
  const [selectedChartBreakdown, setSelectedChartBreakdown] = useState(null);
  const [collectCharmImg, setCollectCharmImg] = useState(null);
  const [showZodiacTooltip, setShowZodiacTooltip] = useState(false);
  const [showBaziTooltip, setShowBaziTooltip] = useState(false);
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [dob, setDob] = useState("");
  const [showTutorial, setShowTutorial] = useState(false);
  const [hideTutorial, setHideTutorial] = useState(false);
  const [checkCharm, setCheckCharm] = useState();
  const [showModal, setShowModal] = useState(false);
  const [charmRedeemed, setCharmRedeemed] = useState();
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewSrc, setPreviewSrc] = useState(null);
  const [showAmuletGuide, setShowAmuletGuide] = useState(false);
  const [loading, setLoading] = useState(false);

  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  // Log when component mounts to ensure this code is executed
  useEffect(() => {
    console.log("NatalChart mounted", {
      userID,
      userName,
      username,
      dob,
      pathname: location?.pathname,
    });
  }, []);

  const chartConfig = [
    { key: "WEALTH", label: t("natalChart.wealth"), color: "#FFD700" },
    { key: "CAREER", label: t("natalChart.career"), color: "#32CD32" },
    { key: "RS", label: t("natalChart.relationship"), color: "#1E90FF" },
    { key: "HEALTH", label: t("natalChart.health"), color: "#FF6347" },
    { key: "WISDOM", label: t("natalChart.wisdom"), color: "#8A2BE2" },
  ];

  const getScoreValue = (table, key) => {
    if (!table) return 0;
    if (table[`${key}_TOTAL`] !== undefined && table[`${key}_TOTAL`] !== null) {
      return Number(table[`${key}_TOTAL`]);
    }
    // Fallback: Sum part 1 and part 2 if total is missing
    const part1 = Number(table[key]) || 0;
    const part2 = Number(table[`${key}1`]) || 0;
    if (part1 || part2) return part1 + part2;

    // Case-insensitive fallback
    const k = key.toLowerCase();
    for (const tk of Object.keys(table)) {
      if (tk.toLowerCase() === `${k}_total`) return Number(table[tk]);
      if (tk.toLowerCase() === k) return Number(table[tk]);
    }
    return 0;
  };

  const getScoreCategory = (value) => {
    const score = Number(value) || 0;
    if (score >= 0 && score <= 20) return t("natalChart.turbulent");
    if (score > 20 && score <= 40) return t("natalChart.developing");
    if (score > 40 && score <= 60) return t("natalChart.fine");
    if (score > 60 && score <= 80) return t("natalChart.good");
    if (score > 80 && score <= 100) return t("natalChart.excellent");
    return "";
  };

  const getDirectIndirectScoreCategory = (value) => {
    const score = Number(value) || 0;
    if (score >= 0 && score <= 10) return t("natalChart.turbulent");
    if (score > 10 && score <= 20) return t("natalChart.developing");
    if (score > 20 && score <= 30) return t("natalChart.fine");
    if (score > 30 && score <= 40) return t("natalChart.good");
    if (score > 40 && score <= 50) return t("natalChart.excellent");
    return "";
  };

  const fetchForecastData = async (year, month, day, time) => {
    try {
      const uid = userID || "0";
      // Use raw numbers without padding to match working GetLunarHeavenlyStems call
      let url = `https://xianhefairy.com/LotusFairy_API/api/member/GetNatalDailyForecast?cYear=${year}&cMonth=${month}&cDay=${day}&cTime=${time}&CustID=${uid}`;
      let res = await axios.get(url);
      let data = res.data;

      if (!data || !data.Table || !data.Table1 || !data.Table2) {
        url = `https://xianhefairy.com/LotusFairy_API/api/member/GetNatalDailyForecast?cYear=${year}&cMonth=${month}&cDay=${day}`;
        res = await axios.get(url);
        data = res.data;
      }

      if (data) {
        const yearly = data.Table?.[0] || null;
        const monthly = data.Table1?.[0] || null;
        const daily = data.Table2?.[0] || null;
        setForecastTables([daily, monthly, yearly]);
      }
    } catch (error) {
      console.error("Forecast Error:", error);
    }
  };

  const fetchLunarData = async (year, month, day, time = "22:59") => {
    try {
      const langId = localStorage.getItem("languageId") || 2224;
      const requestBody = {
        cYear: year,
        cMonth: month,
        cDay: day,
        cTime: time,
        CustID: parseInt(userID, 10) || 0,
        LangId: parseInt(langId, 10),
      };

      console.log(
        "API Request URL:",
        "https://xianhefairy.com/LotusFairy_API/api/member/GetLunarHeavenlyStem",
      );
      console.log("API Request Body:", requestBody);

      const response = await fetch(
        "https://xianhefairy.com/LotusFairy_API/api/member/GetLunarHeavenlyStem",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestBody),
        },
      );

      if (!response.ok) {
        throw new Error(`Failed request: ${response.status}`);
      }

      const responseData = await response.json();
      console.log("API Response Data:", responseData);

      const data = responseData?.[0];
      if (data) {
        console.log("Chart Values:", {
          WEALTH_TOTAL: data.WEALTH_TOTAL,
          CAREER_TOTAL: data.CAREER_TOTAL,
          RS_TOTAL: data.RS_TOTAL,
          HEALTH_TOTAL: data.HEALTH_TOTAL,
          WISDOM_TOTAL: data.WISDOM_TOTAL,
        });

        setLunarData({
          ...data,
          NATAL: (data.NATAL || "").trim(),
          STEM_RELATION: (data.STEM_RELATION || "").trim(),
          STEM_DESCRIPTION: data.STEM_DESCRIPTION,
          ZODIAC_DESCRIPTION: data.ZODIAC_DESCRIPTION,
        });
        console.log("Lunar data fetched successfully:", data);
      }
    } catch (error) {
      console.error("Error fetching lunar data:", error);
    }
  };

  const loadUserForecast = async () => {
    console.log("loadUserForecast start", { userID, userName });
    if (!userID || !userName) {
      console.log("loadUserForecast - missing credentials", {
        userID,
        userName,
      });
      setIsDobMissing(true);
      return;
    }
    setLoading(true);
    try {
      const res = await axios.post(
        "https://xianhefairy.com/LotusFairy_API/api/User/GetProfile",
        {
          UserName: userName,
          ID: userID,
          UserToken: "",
          Token: {
            AccessToken: "xAfhn90xflfHfd.fjldfj@fdhLXHCHchlhsdflsdfhawWFRwzxxp",
          },
        },
      );

      const profile = res.data?.Profiles?.[0];
      if (!profile || !profile.DOB) {
        setIsDobMissing(true);
        setLoading(false);
        return;
      }

      setEmail(profile.Email);
      setUsername(profile.FullName);
      setDob(profile.DOB);

      // Multi-format date parser
      let dobDate = new Date(profile.DOB);
      if (isNaN(dobDate.getTime()))
        dobDate = new Date(profile.DOB.replace(/-/g, "/"));
      if (isNaN(dobDate.getTime())) {
        const parts = profile.DOB.split(/[-/]/);
        if (parts.length === 3) {
          dobDate = new Date(`${parts[2]}/${parts[1]}/${parts[0]}`);
        }
      }

      if (isNaN(dobDate.getTime())) {
        setIsDobMissing(true);
        return;
      }

      const year = dobDate.getFullYear();
      const month = dobDate.getMonth() + 1;
      const day = dobDate.getDate();
      const time =
        `${dobDate.getHours().toString().padStart(2, "0")}:${dobDate.getMinutes().toString().padStart(2, "0")}` ||
        "22:59";

      await Promise.all([
        fetchForecastData(year, month, day, time === "00:00" ? "22:59" : time),
        fetchLunarData(year, month, day, time === "00:00" ? "22:59" : time),
      ]);
    } catch (err) {
      console.error("Load Error:", err);
    } finally {
      setLoading(false);
    }
  };

  const handleEditProfileClick = (e) => {
    e && e.stopPropagation();
    console.log("Edit profile click - current values", {
      userID,
      userName,
      username,
      dob,
      location: location?.pathname,
    });
    navigate("/edit-profile");
  };

  useEffect(() => {
    loadUserForecast();
  }, [userID]);

  useEffect(() => {
    const fetchCollectCharmImg = async () => {
      try {
        const res = await fetch(
          "https://xianhefairy.com/LotusFairy_API/api/member/services/images",
        );
        const data = await res.json();
        if (
          Array.isArray(data) &&
          data.length > 0 &&
          data[0].Image &&
          data[0].ProdId
        ) {
          const prodId = String(data[0].ProdId).padStart(5, "0");
          const filename = data[0].Image;
          const url = `https://xianhefairy.com:4433/images/services/${prodId}/${filename}`;
          setCollectCharmImg(url);
        }
      } catch (err) {
        setCollectCharmImg(null);
      }
    };
    fetchCollectCharmImg();
  }, []);

  const handleClick = async () => {
    if (!dob) {
      alert("Date of Birth not available.");
      return;
    }
    try {
      setLoading(true);
      const dobDate = new Date(dob.replace(/-/g, "/"));
      const year = dobDate.getFullYear();
      const month = dobDate.getMonth() + 1;
      const day = dobDate.getDate();
      const url = `https://xianhefairy.com/LotusFairy_API/api/member/GetNatalDailyForecast?cYear=${year}&cMonth=${month}&cDay=${day}`;
      const response = await fetch(url);
      const data = await response.json();
      navigate("/chart2", { state: { natalChart: data } });
    } catch (error) {
      console.error("Error fetching natal chart:", error);
      alert("Failed to fetch natal chart.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (lunarData || forecastTables[0]) {
      console.log("[useEffect] Tips loading triggered", {
        hasLunarData: !!lunarData,
        hasDaily: !!forecastTables[0],
        lunarNatal: lunarData?.NATAL,
      });

      const welcomeTip = {
        title: "Welcome",
        content:
          "Welcome to XianHeFairy.com! Need any help? Please click the 'Get Started' button for a quick guide tour",
      };

      const lifeData = lunarData || {};
      if (lunarData) {
        console.log(
          "[useEffect] Calling getTipsForPeriod for Lunar with data:",
          {
            WEALTH_TOTAL: getScoreValue(lifeData, "WEALTH"),
            CAREER_TOTAL: getScoreValue(lifeData, "CAREER"),
            RS_TOTAL: getScoreValue(lifeData, "RS"),
            HEALTH_TOTAL: getScoreValue(lifeData, "HEALTH"),
            WISDOM_TOTAL: getScoreValue(lifeData, "WISDOM"),
          },
        );
        getTipsForPeriod("Lunar", {
          WEALTH_TOTAL: getScoreValue(lifeData, "WEALTH") || 50,
          CAREER_TOTAL: getScoreValue(lifeData, "CAREER") || 50,
          RS_TOTAL: getScoreValue(lifeData, "RS") || 50,
          HEALTH_TOTAL: getScoreValue(lifeData, "HEALTH") || 50,
          WISDOM_TOTAL: getScoreValue(lifeData, "WISDOM") || 50,
        }).then((tips) => {
          console.log("[useEffect] Lunar tips received:", tips);
          setTipsData((prev) => ({ ...prev, Life: [welcomeTip, ...tips] }));
        });
      }

      if (forecastTables[0]) {
        console.log("[useEffect] Calling getTipsForPeriod for Daily");
        getTipsForPeriod("Daily", forecastTables[0]).then((tips) => {
          console.log("[useEffect] Daily tips received:", tips);
          setTipsData((prev) => ({ ...prev, Daily: tips }));
        });
      }
      if (forecastTables[1]) {
        console.log("[useEffect] Calling getTipsForPeriod for Monthly");
        getTipsForPeriod("Monthly", forecastTables[1]).then((tips) => {
          console.log("[useEffect] Monthly tips received:", tips);
          setTipsData((prev) => ({ ...prev, Monthly: tips }));
        });
      }
      if (forecastTables[2]) {
        console.log("[useEffect] Calling getTipsForPeriod for Yearly");
        getTipsForPeriod("Yearly", forecastTables[2]).then((tips) => {
          console.log("[useEffect] Yearly tips received:", tips);
          setTipsData((prev) => ({ ...prev, Yearly: tips }));
        });
      }
    }
  }, [lunarData, forecastTables]);

  const getTabTipsKey = (tab) => {
    if (tab === "natal") return "Life";
    return tab.charAt(0).toUpperCase() + tab.slice(1);
  };

  const handleTabChange = async (tab) => {
    setActiveTab(tab);
    setShowTutorial(false); // Reset tips view when changing tabs

    if (tab === "natal" && dob) {
      const dobDate = new Date(dob.replace(/-/g, "/"));
      if (!isNaN(dobDate.getTime())) {
        const year = dobDate.getFullYear();
        const month = dobDate.getMonth() + 1;
        const day = dobDate.getDate();
        const time = `${dobDate.getHours().toString().padStart(2, "0")}:${dobDate.getMinutes().toString().padStart(2, "0")}`;
        await fetchLunarData(
          year,
          month,
          day,
          time === "00:00" ? "22:59" : time,
        );
      }
    }
  };

  const getCurrentTable = () => {
    switch (activeTab) {
      case "daily":
        return forecastTables[0];
      case "monthly":
        return forecastTables[1];
      case "yearly":
        return forecastTables[2];
      case "natal":
      default:
        return lunarData;
    }
  };

  const handleChartClick = async (label, index) => {
    const table = getCurrentTable();
    if (!table) return;

    const actualScore = getScoreValue(table, label);

    setSelectedChartLabel(label);
    setChartDataForChatbot({ [label]: actualScore });

    const period =
      activeTab === "natal"
        ? "Lunar"
        : activeTab.charAt(0).toUpperCase() + activeTab.slice(1);
    const tips = await getThreeTipsForChart(period, label, table);

    const tipsKey = getTabTipsKey(activeTab);
    setTipsData((prev) => ({ ...prev, [tipsKey]: tips }));
    setCurrentTipIndex((prev) => ({ ...prev, [tipsKey]: 0 }));
    setShowTutorial(true);

    setSelectedChartBreakdown({
      label,
      part1: table[label] || 0,
      part2: table[`${label}1`] || 0,
    });
  };

  const getRelevanceRange = (value) => {
    value = Number(value) || 0;
    if (value <= 20) return "0-20";
    if (value <= 40) return "21-40";
    if (value <= 60) return "41-60";
    if (value <= 80) return "61-80";
    return "81-100";
  };

  const getDirectIndirectRelevanceRange = (value) => {
    value = Number(value) || 0;
    if (value <= 10) return "0-10";
    if (value <= 20) return "11-20";
    if (value <= 30) return "21-30";
    if (value <= 40) return "31-40";
    return "41-50";
  };

  const getTipsForPeriod = async (period, table) => {
    console.log(`[getTipsForPeriod] Starting for period: ${period}`, {
      table,
      lunarNatal: lunarData?.NATAL,
    });
    const tips = await Promise.all(
      chartConfig.map(async (config) => {
        const value = getScoreValue(table, config.key);
        const score = getRelevanceRange(value);
        const category = config.key === "RS" ? "RELATIONSHIP" : config.key;

        // Map category keys to API category labels
        const categoryMap = {
          WEALTH: "General Wealth",
          CAREER: "General Career",
          WISDOM: "General Wisdom",
          RELATIONSHIP: "General Relationship",
          HEALTH: "General Health",
        };
        const mainCategory = categoryMap[config.key] || `General ${category}`;

        // Map "Lunar" to "NATAL" for API
        const apiPeriod =
          period.toUpperCase() === "LUNAR" ? "NATAL" : period.toUpperCase();

        const requestBody = {
          Period: apiPeriod,
          A2: lunarData?.NATAL || "",
          MainCategory: mainCategory,
          Score: score,
          LangId: parseInt(localStorage.getItem("languageId") || 2224, 10),
        };

        console.log(
          `[getTipsForPeriod] ${category} - Requesting:`,
          requestBody,
        );

        try {
          const response = await fetch(
            "https://xianhefairy.com/LotusFairy_API/api/booking/GetNatalTips",
            {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify(requestBody),
            },
          );

          if (!response.ok)
            throw new Error(`HTTP error! status: ${response.status}`);
          const responseData = await response.json();
          console.log(
            `[getTipsForPeriod] ${category} - Response:`,
            responseData,
          );

          // Handle array or object response
          let tipData = null;
          if (Array.isArray(responseData) && responseData.length > 0) {
            tipData = responseData[0];
          } else if (
            responseData &&
            typeof responseData === "object" &&
            !Array.isArray(responseData)
          ) {
            tipData = responseData;
          }

          if (!tipData) {
            console.warn(`[getTipsForPeriod] ${category} - No tip data found`);
            return {
              title: `${category}`,
              apiCategory: null,
              content: "No tips available for this category.",
              chatHuman: "",
              relevance: "",
            };
          }

          console.log(
            `[getTipsForPeriod] ${category} - Selected tip:`,
            tipData,
          );

          return {
            title: `${category}`,
            apiCategory:
              tipData.Category || tipData.MainCategory || mainCategory,
            content: tipData.Tip || "No tip content found.",
            chatHuman: tipData.ChatHuman || "",
            relevance: tipData.Relevance || "",
          };
        } catch (error) {
          console.error(
            `[getTipsForPeriod] ${category} - Error:`,
            error.message,
          );
          return {
            title: `${category}`,
            apiCategory: null,
            content: "Error fetching tip.",
            chatHuman: "",
            relevance: "",
          };
        }
      }),
    );
    console.log(`[getTipsForPeriod] Completed for ${period}:`, tips);
    return tips;
  };

  const getThreeTipsForChart = async (period, chartLabel, scoresTable) => {
    // NATAL identifier always comes from lunarData (natal chart)
    if (!lunarData || !lunarData.NATAL) {
      console.warn(
        "lunarData or lunarData.NATAL is undefined in getThreeTipsForChart:",
        lunarData,
      );
      return [
        {
          title: t("natalChart.dataLoadingTitle"),
          content: t("natalChart.lunarDataLoading"),
          chatHuman: "",
          relevance: "",
        },
      ];
    }

    const natalId = lunarData.NATAL;

    // Score values come from the current tab's table (daily/monthly/yearly/natal)
    const scoreSource = scoresTable || lunarData;

    const part1Key = chartLabel;
    const part2Key = `${chartLabel}1`;

    const totalValue = getScoreValue(scoreSource, chartLabel);
    const part1Value = scoreSource[part1Key] || 0;
    const part2Value = scoreSource[part2Key] || 0;

    const getTip = async (category, value, label, isDirectIndirect = false) => {
      const score = isDirectIndirect
        ? getDirectIndirectRelevanceRange(value)
        : getRelevanceRange(value);

      try {
        const storedLangId = localStorage.getItem("languageId");
        const langId = storedLangId ? parseInt(storedLangId, 10) : 2224;

        const apiPeriod =
          String(period || "NATAL").toUpperCase() === "LUNAR"
            ? "NATAL"
            : String(period || "NATAL").toUpperCase();
        const requestBody = {
          Period: apiPeriod,
          A2: natalId,
          MainCategory: category,
          Score: score,
          LangId: langId,
        };

        console.log("[getTip] Request body:", requestBody);

        const response = await fetch(
          "https://xianhefairy.com/LotusFairy_API/api/booking/GetNatalTips",
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(requestBody),
          },
        );

        if (!response.ok)
          throw new Error(`HTTP error! status: ${response.status}`);
        const responseData = await response.json();
        console.log(`Raw tip response for ${label}:`, responseData);

        // Normalize API responses into an array of tip objects
        let tips = [];
        if (Array.isArray(responseData)) {
          tips = responseData;
        } else if (Array.isArray(responseData?.Table1)) {
          tips = responseData.Table1;
        } else if (Array.isArray(responseData?.Table)) {
          tips = responseData.Table;
        } else if (
          responseData?.Table1 &&
          typeof responseData.Table1 === "object"
        ) {
          tips = [responseData.Table1];
        } else if (
          responseData?.Table &&
          typeof responseData.Table === "object"
        ) {
          tips = [responseData.Table];
        } else if (
          responseData &&
          typeof responseData === "object" &&
          Object.keys(responseData).length > 0
        ) {
          tips = [responseData];
        } else {
          tips = [];
        }

        if (tips.length === 0) {
          console.warn(
            `[getTip] No tips returned for MainCategory='${category}'. Trying fallbacks...`,
          );
          // Try fallback category names for cases where API expects different labels (especially CAREER)
          const fallbacks = [];
          if (category && typeof category === "string") {
            const clean = category.replace(/^General\s+/i, "").trim();
            if (clean && clean !== category) fallbacks.push(clean);
            // common alternate for career
            if (/career/i.test(category)) fallbacks.push("Career Advancement");
          }

          for (const fb of fallbacks) {
            try {
              const fbRequest = { ...requestBody, MainCategory: fb };
              console.log(
                `[getTip] Retrying with fallback MainCategory='${fb}'`,
                fbRequest,
              );
              const fbResp = await fetch(
                "https://xianhefairy.com/LotusFairy_API/api/booking/GetNatalTips",
                {
                  method: "POST",
                  headers: { "Content-Type": "application/json" },
                  body: JSON.stringify(fbRequest),
                },
              );
              if (!fbResp.ok) {
                console.warn(
                  `[getTip] Fallback request failed status=${fbResp.status}`,
                );
                continue;
              }
              const fbData = await fbResp.json();
              let fbTips = [];
              if (Array.isArray(fbData)) fbTips = fbData;
              else if (Array.isArray(fbData?.Table1)) fbTips = fbData.Table1;
              else if (Array.isArray(fbData?.Table)) fbTips = fbData.Table;
              else if (fbData?.Table1 && typeof fbData.Table1 === "object")
                fbTips = [fbData.Table1];
              else if (fbData?.Table && typeof fbData.Table === "object")
                fbTips = [fbData.Table];
              else if (
                fbData &&
                typeof fbData === "object" &&
                Object.keys(fbData).length > 0
              )
                fbTips = [fbData];

              if (fbTips.length > 0) {
                const sel = [...fbTips].sort(
                  (a, b) => (b.ID || 0) - (a.ID || 0),
                )[0];
                return {
                  title: `${label}`,
                  apiCategory:
                    sel?.Category || sel?.CATEGORY || sel?.MainCategory || fb,
                  content: sel?.TIP || sel?.Tip || t("natalChart.noTipFound"),
                  chatHuman: sel?.TIPS_CHAT_HUMAN || sel?.ChatHuman || "",
                  relevance: sel?.RELEVANCE || sel?.Relevance || "",
                };
              }
            } catch (e) {
              console.warn(
                `[getTip] Fallback fetch error for '${fb}':`,
                e?.message || e,
              );
            }
          }

          return {
            title: `${label}`,
            content: t("natalChart.noTipsForRange"),
            chatHuman: "",
            relevance: "",
          };
        }

        const selectedTip = [...tips].sort(
          (a, b) => (b.ID || 0) - (a.ID || 0),
        )[0];
        console.log(`[getTip] Selected tip for ${label}:`, selectedTip);
        const apiCategory =
          selectedTip?.Category ||
          selectedTip?.CATEGORY ||
          selectedTip?.MainCategory ||
          null;

        return {
          title: `${label}`,
          apiCategory: apiCategory,
          content:
            selectedTip?.TIP || selectedTip?.Tip || t("natalChart.noTipFound"),
          chatHuman:
            selectedTip?.TIPS_CHAT_HUMAN || selectedTip?.ChatHuman || "",
          relevance: selectedTip?.RELEVANCE || selectedTip?.Relevance || "",
        };
      } catch (error) {
        console.error(`Error fetching tip for ${label}:`, error);
        return {
          title: `${label}`,
          content: t("natalChart.errorFetchingTip"),
          chatHuman: "",
          relevance: "",
        };
      }
    };

    // Map chart key to API category labels (general/direct/indirect)
    const formatCategory = (label, type) => {
      const categoryMap = {
        WEALTH: {
          total: "General Wealth",
          direct: "Direct Wealth",
          indirect: "Indirect Wealth",
        },
        CAREER: {
          total: "General Career",
          direct: "Direct Career",
          indirect: "Indirect Career",
        },
        WISDOM: {
          total: "General Wisdom",
          direct: "Direct Wisdom",
          indirect: "Indirect Wisdom",
        },
        RS: {
          total: "General Relationship",
          direct: "Direct Relationship",
          indirect: "Indirect Relationship",
        },
        HEALTH: {
          total: "General Health",
          direct: "Direct Health",
          indirect: "Indirect Health",
        },
      };

      const mapped = categoryMap[label]?.[type];
      if (mapped) return mapped;
      if (type === "total")
        return `General ${label.charAt(0) + label.slice(1).toLowerCase()}`;
      if (type === "direct")
        return `Direct ${label.charAt(0) + label.slice(1).toLowerCase()}`;
      if (type === "indirect")
        return `Indirect ${label.charAt(0) + label.slice(1).toLowerCase()}`;
      return label;
    };

    const baseLabel = chartLabel;

    const [totalTip, part1Tip, part2Tip] = await Promise.all([
      getTip(
        formatCategory(baseLabel, "total"),
        totalValue,
        formatCategory(baseLabel, "total"),
      ),
      getTip(
        formatCategory(baseLabel, "direct"),
        part1Value,
        formatCategory(baseLabel, "direct"),
        true,
      ),
      getTip(
        formatCategory(baseLabel, "indirect"),
        part2Value,
        formatCategory(baseLabel, "indirect"),
        true,
      ),
    ]);

    return [totalTip, part1Tip, part2Tip];
  };

  const CircularBarChart = ({ label, value, color, onClick }) => {
    const val = Math.max(0, Math.min(Number(value) || 0, 100));
    const fillPercent = val;
    const size = 180;
    const strokeWidth = 20;
    const center = size / 2;
    const radius = (size - strokeWidth) / 2;
    const circumference = 2 * Math.PI * radius;
    const offset = circumference - (fillPercent / 100) * circumference;
    const separatorAngles = [0, 20, 40, 60, 80, 100].map(
      (val) => (val / 100) * 360,
    );
    const scoreCategory = getScoreCategory(val);

    return (
      <div
        style={{
          marginBottom: "20px",
          cursor: "pointer",
          padding: "10px",
          borderRadius: "8px",
          transition: "background-color 0.25s ease",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
        onClick={onClick}
        onMouseOver={(e) =>
          (e.currentTarget.style.backgroundColor = "rgba(223, 189, 105, 0.12)")
        }
        onMouseOut={(e) =>
          (e.currentTarget.style.backgroundColor = "transparent")
        }
      >
        <div
          style={{
            fontWeight: "bold",
            color: "#deaf77",
            marginBottom: "15px",
            fontSize: "18px",
          }}
        >
          {label}
        </div>
        <div style={{ position: "relative", width: size, height: size }}>
          <svg width={size} height={size}>
            <circle
              cx={center}
              cy={center}
              r={radius}
              fill="none"
              stroke="#1f1f1f"
              strokeWidth={strokeWidth}
              transform={`rotate(-90 ${center} ${center})`}
            />
            <circle
              cx={center}
              cy={center}
              r={radius}
              fill="none"
              stroke={color}
              strokeWidth={strokeWidth}
              strokeDasharray={circumference}
              strokeDashoffset={offset}
              transform={`rotate(-90 ${center} ${center})`}
              style={{
                transition: "stroke-dashoffset 0.5s ease",
                filter: "drop-shadow(0 0 6px rgba(0,0,0,0.35))",
              }}
            />
            {separatorAngles.slice(0, -1).map((angle, idx) => {
              const rad = (angle * Math.PI) / 180;
              const x1 = center + (radius - strokeWidth / 2) * Math.cos(rad);
              const y1 = center + (radius - strokeWidth / 2) * Math.sin(rad);
              const x2 = center + (radius + strokeWidth / 2) * Math.cos(rad);
              const y2 = center + (radius + strokeWidth / 2) * Math.sin(rad);
              return (
                <line
                  key={idx}
                  x1={x1}
                  y1={y1}
                  x2={x2}
                  y2={y2}
                  stroke="#deaf77"
                  strokeWidth="4"
                  transform={`rotate(-90 ${center} ${center})`}
                />
              );
            })}
          </svg>
          <div
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              textAlign: "center",
            }}
          >
            <div
              style={{
                fontSize: "20px",
                fontWeight: "bold",
                color: color,
                marginBottom: "4px",
              }}
            >
              {scoreCategory}
            </div>
            <div style={{ fontSize: "16px", color: "#deaf77" }}>
              {val.toFixed(2)}%
            </div>
          </div>
        </div>
      </div>
    );
  };

  const isCharmCollectedToday = () => {
    if (!checkCharm) return false;
    const now = new Date();
    const todayStr = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}-${String(now.getDate()).padStart(2, "0")}`;
    const collectionDateStr = checkCharm.split("T")[0];
    return todayStr === collectionDateStr;
  };

  const handleClickModal = (e) => {
    e.stopPropagation();
    if (isCharmCollectedToday()) {
      setShowModal(true);
    } else {
      navigate("/DigitalCharm");
    }
  };

  const ButtonsContainer = ({ children }) => (
    <div
      style={{
        display: "flex",
        flexDirection: isMobile ? "column" : "row",
        justifyContent: "center",
        alignItems: "center",
        gap: isMobile ? "10px" : "15px",
        marginTop: "20px",
        marginBottom: "60px",
      }}
    >
      {children}
    </div>
  );

  return (
    <div
      style={{
        width: "100%",
        margin: "0",
        position: "relative",
        background: "transparent",
        minHeight: "100vh",
        overflowX: "hidden",
      }}
    >
      <div
        style={{
          padding: "80px 0px 80px 0px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          width: "100%",
          paddingLeft: "20px",
          paddingRight: "20px",
          boxSizing: "border-box",
          position: "relative",
          zIndex: 1,
        }}
      >
        <JourneySection
          isMobile={isMobile}
          t={t}
          onNavigate={(path) => navigate(path)}
        />

        <div style={{ width: "100%", maxWidth: "1200px" }}>
          {lunarData && (
            <div style={{ marginBottom: "60px" }}>
              <DestinyHeader lunarData={lunarData} t={t} isMobile={isMobile} />

              {/* Categorization Tabs */}
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  gap: "15px",
                  flexWrap: "wrap",
                  marginTop: "30px",
                }}
              >
                <NatalTabButton
                  active={activeTab === "daily"}
                  onClick={() => handleTabChange("daily")}
                >
                  {t("natalChart.daily")}
                </NatalTabButton>
                <NatalTabButton
                  active={activeTab === "monthly"}
                  onClick={() => handleTabChange("monthly")}
                >
                  {t("natalChart.monthly")}
                </NatalTabButton>
                <NatalTabButton
                  active={activeTab === "yearly"}
                  onClick={() => handleTabChange("yearly")}
                >
                  {t("natalChart.yearly")}
                </NatalTabButton>
                <NatalTabButton
                  active={activeTab === "natal"}
                  onClick={() => handleTabChange("natal")}
                >
                  {t("natalChart.natal", "Natal")}
                </NatalTabButton>
              </div>
            </div>
          )}

          {lunarData || forecastTables[0] ? (
            <>
              {/* Category-Specific Header */}
              {/* <div style={{ textAlign: 'center', marginBottom: '40px' }}>
                <h3 style={{ color: "#deaf77", marginBottom: "10px", fontSize: "32px", textTransform: 'capitalize' }}>
                  {t(`natalChart.${activeTab}`)} {t("natalChart.yourLifeChart")}
                </h3>
              </div> */}

              {/* Score Circles - Changes based on Tab */}
              <CircleContainer>
                {chartConfig.map((config, i) => {
                  const table = getCurrentTable();
                  const value = getScoreValue(table, config.key);
                  return (
                    <CircularBarChart
                      key={`${activeTab}-${i}`}
                      label={config.label}
                      value={value}
                      color={config.color}
                      onClick={() => handleChartClick(config.key, i)}
                    />
                  );
                })}
              </CircleContainer>

              {/* Action Buttons */}
              <ButtonsContainer>
                <button
                  onClick={() => navigate("/fortune-stick")}
                  style={{
                    width: isMobile ? "100%" : "280px",
                    height: "56px",
                    fontSize: "16px",
                    backgroundColor: "transparent",
                    color: "#deaf77",
                    border: "2px solid #deaf77",
                    borderRadius: "40px",
                    cursor: "pointer",
                    fontWeight: "bold",
                    transition: "all 0.3s",
                  }}
                >
                  {t("natalChart.fortuneStick")}
                </button>
                <button
                  onClick={() => navigate("/shop")}
                  style={{
                    width: isMobile ? "100%" : "280px",
                    height: "56px",
                    fontSize: "16px",
                    backgroundColor: "#deaf77",
                    color: "#000",
                    border: "2px solid #deaf77",
                    borderRadius: "40px",
                    cursor: "pointer",
                    fontWeight: "bold",
                    transition: "all 0.3s",
                  }}
                >
                  {t("natalChart.boostYourLuck")}
                </button>
                <button
                  onClick={handleClickModal}
                  style={{
                    width: isMobile ? "100%" : "280px",
                    height: "56px",
                    fontSize: "16px",
                    backgroundColor: "transparent",
                    color: "#deaf77",
                    border: "2px solid #deaf77",
                    borderRadius: "40px",
                    cursor: "pointer",
                    fontWeight: "bold",
                    transition: "all 0.3s",
                  }}
                >
                  {isCharmCollectedToday()
                    ? t("natalChart.amuletCollected")
                    : t("natalChart.collectAmulet")}
                </button>
              </ButtonsContainer>
            </>
          ) : isDobMissing ? (
            <div
              style={{
                textAlign: "center",
                padding: "60px 20px",
                backgroundColor: "rgba(223, 189, 105, 0.05)",
                borderRadius: "20px",
                border: "1px dashed #deaf77",
              }}
            >
              <p
                style={{
                  fontSize: "22px",
                  marginBottom: "30px",
                  color: "#deaf77",
                }}
              >
                {t("natalChart.signInMessage")}
              </p>
              {userID && username ? (
                <button
                  onClick={handleEditProfileClick}
                  style={{
                    padding: "15px 40px",
                    backgroundColor: "#deaf77",
                    color: "#000",
                    border: "none",
                    borderRadius: "30px",
                    cursor: "pointer",
                    fontWeight: "bold",
                    fontSize: "18px",
                  }}
                >
                  {t("account.oneTimeEditProfile")}
                </button>
              ) : (
                <button
                  onClick={() => {
                    localStorage.setItem("openLoginPanel", "true");
                    navigate("/main");
                  }}
                  style={{
                    padding: "15px 40px",
                    backgroundColor: "#deaf77",
                    color: "#000",
                    border: "none",
                    borderRadius: "30px",
                    cursor: "pointer",
                    fontWeight: "bold",
                    fontSize: "18px",
                  }}
                >
                  {t("account.signIn", "Sign In")}
                </button>
              )}
            </div>
          ) : fetchError ? (
            <div style={{ textAlign: "center", padding: "60px 20px" }}>
              <p
                style={{
                  fontSize: "22px",
                  color: "#ff6b6b",
                  marginBottom: "30px",
                }}
              >
                {fetchError}
              </p>
              <button
                onClick={loadUserForecast}
                style={{
                  background: "transparent",
                  border: "2px solid #deaf77",
                  color: "#deaf77",
                  padding: "12px 30px",
                  borderRadius: "30px",
                  cursor: "pointer",
                  fontWeight: "bold",
                }}
              >
                {t("unsubscribe.retry")}
              </button>
            </div>
          ) : (
            <div style={{ textAlign: "center", padding: "60px 20px" }}>
              <div
                style={{
                  marginBottom: "30px",
                  width: "60px",
                  height: "60px",
                  border: "4px solid rgba(223, 189, 105, 0.1)",
                  borderTop: "4px solid #deaf77",
                  borderRadius: "50%",
                  animation: "spin 1s linear infinite",
                  margin: "0 auto",
                }}
              ></div>
              <p style={{ color: "#deaf77", fontSize: "22px" }}>
                {t("natalChart.loadingNatalChart")}
              </p>
            </div>
          )}
        </div>
      </div>

      {showTutorial && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0, 0, 0, 0.7)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 999999, // Ensure it sits above the footer
          }}
        >
          <div
            style={{
              ...styles.tutorialContainer,
              margin: 0,
              maxHeight: "85vh",
              overflowY: "auto",
              width: "90%",
              position: "relative",
            }}
          >
            <div
              style={{
                position: "sticky",
                top: "-24px",
                right: 0,
                display: "flex",
                justifyContent: "flex-end",
                background: "#1a1a1a",
                padding: "10px 0",
                zIndex: 10,
                margin: "-10px -10px 10px 0",
              }}
            >
              <button
                onClick={() => setShowTutorial(false)}
                style={{
                  background: "transparent",
                  border: "none",
                  color: "#deaf77",
                  fontSize: "28px",
                  cursor: "pointer",
                  lineHeight: 1,
                  padding: "0 10px",
                }}
              >
                ✕
              </button>
            </div>
            <div style={{ textAlign: "left", padding: "0 10px 10px 10px" }}>
              {tipsData[getTabTipsKey(activeTab)]?.map((tip, idx) => (
                <div
                  key={idx}
                  style={{
                    marginBottom: 30,
                    borderBottom: "1px solid rgba(223, 189, 105, 0.1)",
                    paddingBottom: "20px",
                  }}
                >
                  <h4
                    style={{
                      color: "#deaf77",
                      fontSize: "20px",
                      marginBottom: "6px",
                      fontWeight: "700",
                    }}
                  >
                    {tip.apiCategory || tip.title}
                  </h4>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-start",
                      marginBottom: "10px",
                    }}
                  >
                    <span
                      style={{
                        color: "#deaf77",
                        opacity: 0.9,
                        fontSize: "14px",
                      }}
                    >
                      {tip.relevance || ""}
                    </span>
                  </div>
                  <p
                    style={{
                      color: "#fff",
                      lineHeight: "1.6",
                      fontSize: "16px",
                      marginTop: "0",
                    }}
                  >
                    {tip.content}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
        .destiny-tooltip b {
          color: #deaf77;
        }
      `}</style>
    </div>
  );
};

const styles = {
  tutorialContainer: {
    position: "relative",
    border: "2px solid #deaf77",
    padding: "24px",
    borderRadius: "12px",
    backgroundColor: "#1a1a1a",
    maxWidth: "650px",
    margin: "30px auto",
    boxShadow: "0 4px 20px rgba(223, 189, 105, 0.15)",
    color: "#deaf77",
  },
};

export default ForecastChart;
